<div
    tabindex="-1"
    id="myModal"
    role="dialog"
    class="modal fade in">
    <div class="backdrop"></div>
    <div
        data-show="true"
        role="document"
        class="modal-dialog"
        [class]="modalSize">
        <div class="modal-content">
            <div class="modal-header">
                <button
                    type="button"
                    data-dismiss="modal"
                    aria-label="Close"
                    (click)="closeDialog()"
                    class="close">
                    <i class="nlrp-icon nlrp-icon-close"></i
                ></button>
                <h4 class="modal-title">Modal Title</h4>
            </div>
            <div class="modal-body">
                <p>information-modal works!</p>
            </div>
            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-default nlr-btn-sm"
                    (click)="closeDialog()"
                    >Ok
                </button>
            </div>
        </div>
    </div>
</div>
